// src/components/ContentCard/CardMedia.js
import React from 'react';
import { Box } from '@mui/material';
import StyledMediaContainer from '../../../../components/card/StyledMediaContainer';
import StyledMediaImage from '../../../../components/card/StyledMediaImage';
import CardBadge from '../../../../components/card/CardBadge';

const CardMedia = ({ banner, title, badge }) => (
  <StyledMediaContainer>
    <StyledMediaImage 
      image={banner} 
      alt={title} 
    />
    <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
      <CardBadge label={badge} />
    </Box>
  </StyledMediaContainer>
);

export default CardMedia;